<template>
    <div>
        <div>
            <el-input placeholder="Please enter infoID" v-model="infoID" suffix-icon="el-icon-search" @change="search" clearable
                style="width: 300px;"></el-input>
            <el-date-picker style="margin-left:5px" v-model="date" type="daterange" range-separator="to"
                start-placeholder="start date" end-placeholder="end date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                @change="search">
            </el-date-picker>
            <el-button @click="search" style="margin-left:10px" @change="search" type="primary">search</el-button>
           
        </div>
        <div style="padding-top:5px;padding-bottom: 10px; padding-top: 10px;" >
            <el-button style="margin-left:10px" type="primary" @click="exportData" icon="el-icon-upload2">Export</el-button>
        </div>
        <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="70">
            </el-table-column>
            <el-table-column prop="userInfoID" label="InfoID" width="100" align="center">
            </el-table-column>
            <el-table-column label="position" width="100" align="center" style="padding:0%">
                <template  slot-scope="scope">
                    <img :src="getClsPartImage(scope.row)" alt="部位图片" style="width: 90px; height: 150px;">
                </template>
            </el-table-column>
            <el-table-column label="P1/P2"  width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.p12_mode + ' %' }}
                </template>
            </el-table-column>
            <el-table-column label="P3/P4"  width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.p34_mode + ' %' }}
                </template>
            </el-table-column>
            <el-table-column label="RF1/RF2"  width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.rf12_mode + " %" }}
                </template>
            </el-table-column>
            <el-table-column label="RF3/RF4"  width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.rf34_mode + " %" }}
                </template>
            </el-table-column>
            <el-table-column label="F1"  width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.mode_f1 + " HZ" }}
                </template>
            </el-table-column>
            <el-table-column label="F2"  width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.mode_f2 + " HZ" }}
                </template>
            </el-table-column>
            <el-table-column label="F3"  width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.mode_f3 + " HZ" }}
                </template>
            </el-table-column>
            <el-table-column label="operating hours" width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.work_duration}}
                </template>
            </el-table-column>
            <el-table-column prop="work_date" label="Creation date">
            </el-table-column>
        </el-table>
        <div style="padding:10px 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
    
</template>

<script>
import request from '@/utils/request';
export default {
    data(){
        return{
            breadcrumb_teb:{},
            tableData: [],
            userID: this.$store.state.teb.cl4UserID,
            machine: this.$store.state.teb.machineID,
            pageNum: 1,
            pageSize: 5,
            firstDate: '',
            lastDate: '',
            infoID: '',
            date:[],
            total:0,
        }
    },
    methods:{
        async exportData() {
            if(this.$store.state.teb.default_active.charAt(0)==='3'){
                this.isBlack =0 ;
            }else{
                this.isBlack =1;
            }       
            try {
                const url = `https://www.qihang.store/sb/cl4user/export/userInfo?machine=${this.machine}&userID=${this.userID}&infoID=${this.infoID}&firstDate=${this.firstDate}&lastDate=${this.lastDate}&gender=${this.$store.state.teb.cls_gender}`;
                window.open(url);
            } catch (error) {
                console.error("Error:", error);
            }
        },
        search(){
            this.pageNum =1;
            this.load();
        },
        load() {
            if (this.date && this.date.length > 0) {
                if (this.date[0] && this.date[1]) {
                    this.firstDate = this.date[0];
                    this.lastDate = this.date[1];
                } else {
                    this.firstDate = '';
                    this.lastDate = '';
                }
            } else {
                this.firstDate = '';
                this.lastDate = '';
            }
            request.get("/cl4user/selectToUserInfo", {
                params: {
                    machine: this.machine,
                    userID: this.userID,
                    infoID: this.infoID,
                    firstDate: this.firstDate,
                    lastDate: this.lastDate,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }
            }).then(res => {
                this.tableData = res.data
                this.total = res.count
            })
        },
        getClsPartImage(row){
            if(this.$store.state.teb.cls_gender == 0){
                return require(`@/assets/positionImg/clsPosition/m${row.body_part}.png`)
            }
            return require(`@/assets/positionImg/clsPosition/q${row.body_part}.png`)
        },
        getPartImage(row) {
            return require(`@/assets/positionImg/p${row.position}.png`)
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.load();
        },
        handleCurrentChange(pageNum) {
            this.pageNum = pageNum;
            this.load();
        },
        handleSelectionChange(val){
            this.multipleSelection = val
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.load();
        },
        handleCurrentChange(pageNum) {
            this.pageNum = pageNum;
            this.load();
        },
        switchPosition(){}
    },
    created() {
        this.load()
        this.breadcrumb_teb.name = 'cl4-userinfo'
        this.breadcrumb_teb.pageFlag = 3
        this.breadcrumb_teb.machine = this.machine
        this.breadcrumb_teb.path = '/cl4userinfo'
        this.$store.commit('updateSecondTab',this.breadcrumb_teb)
    },

    setup() {
        
    },

}
</script>

<style>

</style>
